import {
	NAME_MAX_LENGTH,
	PASSWORD_MIN_LENGTH
} from './constants-auth';
// --- local imports ------

export const VALIDATION_ERRORS = {
	NAMES: {
		MUST_BE_STRING: { normal: 'Must be a string.', bold: '' },
		MUST_CONTAIN_ALPHA: { normal: 'First/last name must ', bold: 'contain letters.' },
		TOO_SHORT: { normal: 'Enter a ', bold: 'first/last name.' },
		TOO_LONG: { normal: 'First/last name must be at most ', bold: `${NAME_MAX_LENGTH} letters.` }
	},
	PASSWORDS: {
		MUST_BE_STRING: { normal: 'Password must be a string!', bold: '' },
		TOO_SHORT: { normal: 'Password must be at least ', bold: `${PASSWORD_MIN_LENGTH} characters.` },
		MUST_CONTAIN_NUMBER: { normal: 'Password must contain a ', bold: 'number.' },
		MUST_CONTAIN_LOWERCASE: { normal: 'Password must contain a ', bold: 'lowercase letter.' },
		MUST_CONTAIN_UPPERCASE: { normal: 'Password must contain an ', bold: 'uppercase letter.' },
		MUST_CONTAIN_SPECIAL_CHARACTER: { normal: 'Password must contain a ', bold: 'special character.' },
		CONFIRM_NO_MATCH: { normal: 'Passwords ', bold: 'don\'t match.' }
	},
	EMAIL: {
		REQUIRED: { normal: 'You must ', bold: 'input an email.' },
		INVALID: { normal: 'Email must be ', bold: 'valid.' },
		OPTIONAL_INVALID: { normal: 'You must input a ', bold: 'valid email or nothing at all.' }
	}
};

export default VALIDATION_ERRORS;
